import { useContext } from "react";
import { SharedAdministratorContext } from "./SharedAdministratorContext";

const useSharedAdministrator = () => useContext(SharedAdministratorContext);

export default useSharedAdministrator;
